import React, { useState, useEffect, useRef } from 'react';
import UCILogo from '../assets/UCI.svg.png';

export default function Education() {
  const isSmallScreen = window.innerWidth <= 768;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{marginTop: '10vh',display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <div style={{zIndex: 10, position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>


      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '40px', zIndex: 10, position: 'relative'}}>
            <div style={{
                width: isSmallScreen ? '50px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
            <div style={{fontSize: isSmallScreen ? '35px' : '55px', color: '#333333', textAlign: 'center'}}>
                Education
            </div>
            <div style={{
                width: isSmallScreen ? '50px' : 'clamp(80px, 25vw, 600px)',
                height: '3px',
                backgroundColor: '#333333',
            }}></div>
        </div>


        <a 
        href="https://catalogue.uci.edu/donaldbrenschoolofinformationandcomputersciences/softwareengineering_bs/#text" 
        target="_blank" 
        rel="noreferrer" 
        style={{ textDecoration: 'none', cursor: 'pointer' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        >
            <div style={{
                display: 'inline-flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'center', 
                gap: isSmallScreen ? '5px' : '40px',
                padding: '10px',
                marginTop: '40px',
                borderRadius: '20px',
                backgroundColor: 'transparent',
                border: isHovered ? '2px solid #333333' : '2px solid transparent',
                transition: 'border 0.3s ease, color 0.3s ease'
            }}>
                <img src={UCILogo} 
                alt="Photo of University of California, Irvine"
                style={{
                    width: 'auto', 
                    height: isSmallScreen ? '180px' : '200px'
                }}/>
                { !isSmallScreen && (
                    <div style={{display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'flex-start'}}>
                    <div style={{
                        color: '#333333', 
                        fontSize: isSmallScreen ? '18px' : '30px',
                        transition: 'color 0.3s ease'
                    }}>
                        University Of California, Irvine
                    </div>
                    
                    <div style={{
                        color: '#333333', 
                        fontSize: isSmallScreen ? '18px' : '30px',
                        transition: 'color 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        Software Engineering, B.S.
                        <svg 
                            width="16" 
                            height="16" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="#333333" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                            style={{ flexShrink: 0, transition: 'stroke 0.3s ease' }}
                        >
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                            <polyline points="15 3 21 3 21 9"></polyline>
                            <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                    </div>

                    </div>
                )}
            </div>
        </a>

        {isSmallScreen && (
            <div 
                style={{
                    display: 'inline-flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    marginTop: '10px', 
                    marginBottom: '60px',
                    padding: '20px',
                    borderRadius: '20px',
                    backgroundColor: 'transparent',
                    border: isHovered ? '2px solid #333333' : '2px solid transparent',
                    transition: 'border 0.3s ease, color 0.3s ease'
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
            <div style={{
                color: '#333333', 
                fontSize: isSmallScreen ? '18px' : '30px',
                transition: 'color 0.3s ease'
            }}>
                University Of California, Irvine
            </div>
            <div style={{
                color: '#333333', 
                fontSize: isSmallScreen ? '18px' : '30px',
                transition: 'color 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                Software Engineering, B.S.
                <svg 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="#333333" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    style={{ flexShrink: 0, transition: 'stroke 0.3s ease' }}
                >
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
            </div>
            </div>
        )}
      </div>
    </div>
  );
}